module.exports = __webpack_public_path__ + "img/avatar-mela.ed8306d0.png";